import { getCustomer, getCycleDate } from "../Authorization";

const WrapOption = () => {
  return {
    cycle_date: getCycleDate(),
    customer: getCustomer(),
    wrap_url: process.env.REACT_APP_WRAP_URL,
    expo_map_url: process.env.REACT_APP_EXPO_MAP_URL,
    expo_tile_sat_url: process.env.REACT_APP_EXPO_TILE_SAT_URL,
    expo_tile_gpv_url: process.env.REACT_APP_EXPO_TILE_GPV_URL,
    expo_random_point_url: process.env.REACT_APP_EXPO_RANDOM_POINT_URL,
    expo_live_camera_url: process.env.REACT_APP_EXPO_LIVECAMERA_URL,
    //TODO 下記にはThumbnail Apiがあるので使いたいのだが、運用・開発どちらもpublicしか用意がない & カメラIDに「.」が含まれるとエラーになるためまだ切り替えられない
    // expo_new_live_camera_url: "https://wni-data-expo-api-e.wni.com/camera"
    // expo_new_live_camera_url: "https://dev-expo-api-e.expo-pavilions.pt-aws.wni.com/camera"
    expo_observation_url: process.env.REACT_APP_EXPO_OBSERVATION_URL,
    // ObservationDB_API_NEWはmasterとtimeで地点リストに不一致があるので一旦見送り(masterにあるものがtimeでとれない）
    // expo_observation_url: "https://wni-data-expo-api-e.wni.com/obs"
    numerical_db_gpv_url: process.env.REACT_APP_EXPO_NUMERICAL_DB_GPV_URL,
    expo_status_db_url: process.env.REACT_APP_EXPO_STATUS_DB_URL,
    expo_status_db_dev_url: process.env.REACT_APP_EXPO_STATUS_DB_DEV_URL,
    expo_calendar_url: process.env.REACT_APP_EXPO_CALENDAR_URL,
    expo_gpvtile_url: process.env.REACT_APP_EXPO_GPVTILE_URL,
    metartaf_api_url: process.env.REACT_APP_METARTAF_AVIATION_WEATHER_API_URL,
    flightplan_api_url: process.env.REACT_APP_FLIGHTPLAN_API_URL,
    links_api_url: process.env.REACT_APP_APP_FOSTERLINKS_ADDIN_API_URL,
    arinc_data_auth_api_url: process.env.REACT_APP_ARINC_DATA_AUTH_API_URL,
    arinc_data_url: process.env.REACT_APP_ARINC_DATA_URL,
    livecamera_api_url: process.env.REACT_APP_CAMERA_API_URL,
    position_url: process.env.REACT_APP_POSITION_API_URL,
    soracame_api_url: process.env.REACT_APP_SORACAME_API_URL,
    soracame_image_list_api_url: process.env.REACT_APP_SORACAME_IMAGE_LIST_API_URL,
  }
}
export default WrapOption;